import React from 'react';
import { Modal, Pressable, ScrollView, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';

const NAMES = { '👍': 'Thumbs up', '❤️': 'Heart', '😂': 'Laughing', '😮': 'Surprised', '😢': 'Sad', '🙏': 'Thank you', '👋': 'Wave', '🎉': 'Celebrate', '💡': 'Idea', '👎': 'Thumbs down' };

export default function NativeReactionPicker({ visible, onClose, emojis, selected, onSelect, busy, error }) {
  const { colors } = useTheme();
  const insets = useSafeAreaInsets();
  return <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose} statusBarTranslucent>
    <View style={{ flex: 1, justifyContent: 'flex-end', backgroundColor: 'rgba(0,0,0,0.4)', paddingTop: insets.top + 16 }}>
      <Pressable accessibilityLabel="Close reactions" accessibilityRole="button" onPress={onClose} style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }} />
      <View accessibilityViewIsModal onAccessibilityEscape={onClose} style={{ maxHeight: '100%', width: '100%', maxWidth: 420, alignSelf: 'center', borderTopLeftRadius: 24, borderTopRightRadius: 24, backgroundColor: colors.solid_color_secondary, padding: 16, paddingBottom: Math.max(16, insets.bottom) }}>
        <ScrollView keyboardShouldPersistTaps="handled">
          <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <Text weight="bold" style={{ flex: 1 }}>React to reply</Text>
            <Pressable onPress={onClose} accessibilityRole="button" accessibilityLabel="Close reactions" style={{ minHeight: 44, minWidth: 44, alignItems: 'center', justifyContent: 'center' }}><Text size="s">Done</Text></Pressable>
          </View>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
            {emojis.map(emoji => <View key={emoji} style={{ width: '20%', padding: 3 }}>
              <Pressable onPress={() => onSelect(emoji)} disabled={busy} accessibilityRole="button" accessibilityLabel={NAMES[emoji] || emoji} accessibilityState={{ selected: selected === emoji, disabled: busy }}
                style={({ pressed }) => ({ minHeight: 52, borderRadius: 14, alignItems: 'center', justifyContent: 'center', borderWidth: 2, borderColor: selected === emoji ? colors.text_color_primary : 'transparent', backgroundColor: pressed || selected === emoji ? colors.solid_color_tertiary : 'transparent', opacity: busy ? 0.5 : 1 })}>
                <Text style={{ fontSize: 26 }}>{emoji}</Text>
              </Pressable>
            </View>)}
          </View>
          {!!error && <Text accessibilityRole="alert" color="danger" size="s">{error}</Text>}
        </ScrollView>
      </View>
    </View>
  </Modal>;
}
